import { Grid, Typography } from "@mui/material";
import { SimCardOutlined } from "@mui/icons-material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useGetReplacementCost } from "./hook/useGetReplacementCost";
import { ReplacementSimAddress } from "./ReplacementSimAddress";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    closeForm(): void;
    onSuccessCallback(): void;
}

export const ReplacementSimForm = (props: IParams) => {
    const { closeForm, onSuccessCallback } = props;
    const { t } = useTranslation(["sim", "common"]);
    const { getReplacementCostState, replacementCostDetails, getReplacementCostDetails } = useGetReplacementCost();

    const getReplacementAmount = (replacementCostAmount: number) => t("common:price", { price: replacementCostAmount });

    return (
        <HandleErrorAndLoading
            error={getReplacementCostState.error}
            isLoading={getReplacementCostState.isLoading}
            retryFetch={getReplacementCostDetails}
        >
            {replacementCostDetails && (
                <Fragment>
                    <Grid className="replacementSim__text" container justifyContent="center">
                        <Grid item>
                            <SimCardOutlined color="primary" style={{ fontSize: "41px", marginRight: "8px" }} />
                        </Grid>
                        <Grid item>
                            <Typography color="secondary" variant="h5">
                                <strong>{replacementCostDetails.name}</strong>
                            </Typography>
                            <Typography color="secondary" variant="normal">
                                {t("sim:replacementSimOrderHelper")}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid className="replacementSim__text" container justifyContent="center">
                        <Grid item>
                            <Typography align="center" color="primary" variant="h4">
                                {`${t("sim:cost")}: ${getReplacementAmount(replacementCostDetails.amount)}`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align="center" color="secondary" variant="normal">
                                {t("sim:replacementSimCostText")}
                            </Typography>
                        </Grid>
                    </Grid>
                    <ReplacementSimAddress closeForm={closeForm} onSuccessCallback={onSuccessCallback} />
                </Fragment>
            )}
        </HandleErrorAndLoading>
    );
};
